import type { ComponentProps } from 'react'
import { cn } from '~/lib/utils'

export const SpaceSectionContent = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-col gap-4', className)}
	/>
)
